module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "XK-input"
  }, [(_vm.type == 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.blurFn,
      "change": _vm.changeFn,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.inputFn]
    }
  }) : (_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.blurFn,
      "change": _vm.changeFn,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.inputFn]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.placeholder,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.blurFn,
      "change": _vm.changeFn,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.inputFn]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "closeButDiv",
    on: {
      "click": _vm.closeFn
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "closeBut"
  }, [_c('i', {
    staticClass: "iconfont icon-iconfontclosesmall"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9eeb2e42","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/input/src/input.vue
// module id = 558
// module chunks = 0